module.exports = __webpack_public_path__ + "static/_insta_-f0694fdb9357b444fcbba43ca9b53d77.jpg";